// Module
var code = "<div class=\"blankslate blankslate-spacious\"> <i class=\"far fa-window-close blankslate-icon\"></i> <h3 translate>We can't find what you are looking for.</h3> <p translate>The page you're looking for doesn't exist or has been moved.</p> <a ui-sref=home class=\"btn btn-primary\" translate>Back to Dashboard</a> </div> ";
// Exports
module.exports = code;